import i18next from "i18next";
import moment from "moment";
import React from "react";
import { useGetPersonalInfo } from "../../hooks";
import {
  AdsCard,
  HomeArticles,
  MyAppointmentsCards,
  ProfileCompletionCard,
} from "./Component";

const Home: React.FC = () => {
  const { data: userData } = useGetPersonalInfo();
  const personalData = userData?.Data;
  moment.locale(i18next.language);

  return (
    <div className="flex h-full flex-col gap-4 max-lg:mb-4 max-md:w-full lg:flex-row">
      <div className="flex w-full flex-col gap-3 max-lg:hidden lg:w-2/3">
      <div className="xl:hidden">
          <ProfileCompletionCard
            completePercentage={personalData?.CompletePercentage || 0}
          />
        </div>
        <MyAppointmentsCards />
      </div>
      <div className="flex w-full flex-col gap-3 lg:overflow-y-auto lg:w-1/3">
        <div className="max-xl:hidden">
          <ProfileCompletionCard
            completePercentage={personalData?.CompletePercentage || 0}
          />
        </div>
        <AdsCard />
        <HomeArticles />
      </div>
      {/* <WelcomeModal /> */}
    </div>
  );
};

export default Home;
